import * as z from 'zod';

// CSS selectors schema - Map<ScreenSize, Map<CssSelectorStrategyType, String>>
// Used by Block/BlockVariant API DTOs
export const cssSelectorMapSchema = z.record(z.string(), z.record(z.string(), z.string()));
export type CssSelectorMap = z.infer<typeof cssSelectorMapSchema>;

// Tids schema - Map<ScreenSize, string>
export const tidsSchema = z.record(z.string(), z.string());
export type Tids = z.infer<typeof tidsSchema>;

// Block type enum - shared by Block, BlockVariant and Campaign (embedded) DTOs.
export const blockTypeSchema = z.enum([
  'headline',
  'subtitle',
  'title',
  'description',
  'cta',
  'tagline',
  'badge',
  'faq_question',
  'faq_answer',
  'bio',
  'label',
  'customer_logo',
  'customer_logo',
]);
export type BlockType = z.infer<typeof blockTypeSchema>;

// DataPoint schema - used within TimeSeries
export const dataPointSchema = z.object({
  name: z.string().nullable(),
  date: z.iso.datetime().nullable(),
  value: z.number().nullable(),
});
export type DataPoint = z.infer<typeof dataPointSchema>;

// TimeSeries read schema - API response
export const readTimeSeriesSchema = z.object({
  name: z.string().nullable(),
  series: z.array(dataPointSchema).nullable(),
});
export type ReadTimeSeries = z.infer<typeof readTimeSeriesSchema>;

// Legacy export for convenience
export const timeSeriesSchema = readTimeSeriesSchema;
export type TimeSeries = ReadTimeSeries;

// Tracked event row, embedded in page and campaign statistics.
// ratio is 0.0 - 1.0; format as % in the UI.
export const readTrackedEventSchema = z.object({
  blockId: z.uuid().nullable(),
  eventName: z.string().nullable(),
  count: z.number().nullable(),
  ratio: z.number().nullable(),
  lastSeenAt: z.iso.datetime().nullable(),
});
export type ReadTrackedEvent = z.infer<typeof readTrackedEventSchema>;
